import {
  AccordionDetails,
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  Link,
  Radio,
  RadioGroup,
  Stack
} from '@mui/material';
import React from 'react';
import { useDispatch } from 'react-redux';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useUser } from 'src/components/hooks/useUser';
import { sendRequest } from 'src/hooks/useFetch';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
// import { setSnackbarMessage } from 'src/store/snackbarMessage';
import { clearMessage, setMessage } from 'src/store/Message';
import { ISIVChecklistAdverseEventReporting } from 'src/types/SIVChecklist';
import { formatInput } from 'src/util/STR';
import { useFieldTranslation } from '../../fields/useFieldTranslation';
import {
  IAdverseEventReportingMandatory,
  ISIVChecklistMandatory,
  ISIVChecklistModifiedKeys,
  ISIVChecklistModifiedKeysOfKeys,
  MandatoryData
} from './useSivChecklist';
import { setIsSaveButtonDisable } from 'src/store/sivCheckList';

export interface IAdverseEventReporting {
  getSivChecklistData: (key: ISIVChecklistModifiedKeysOfKeys, add: boolean) => void;
  saveDisable: boolean;
  adverseEventReportingData: ISIVChecklistAdverseEventReporting;
  updateAdverseEventReporting: (data: ISIVChecklistAdverseEventReporting) => void;
  isUpdate: boolean;
  isChange: boolean;
  setIsChange: (step: ISIVChecklistModifiedKeys, key: ISIVChecklistModifiedKeysOfKeys, val: boolean) => void;
  updateSIVChecklistMandatoryData: (key: keyof ISIVChecklistMandatory, value: MandatoryData) => void;
  mandatory: IAdverseEventReportingMandatory;
  validateadverseEventReporting: any;
  checkedInStartDate: any;
  isPublished: boolean;
  SignatureBreaking: () => void;
}

const AdverseEventReporting: React.FunctionComponent<IAdverseEventReporting> = ({
  getSivChecklistData,
  saveDisable,
  adverseEventReportingData,
  updateAdverseEventReporting,
  isUpdate,
  isChange,
  setIsChange,
  mandatory,
  updateSIVChecklistMandatoryData,
  validateadverseEventReporting,
  checkedInStartDate,
  isPublished,
  SignatureBreaking
}) => {
  // const [adverseEventReportingData, setAdverseEventReportingData] = useState<any>({
  //   siv_checklist_ib_isf: sivChecklistData.siv_checklist_ib_isf,
  //   siv_checklist_ib_isf_comm: sivChecklistData.siv_checklist_ib_isf_comm || ''
  // });
  //const [isChange, setIsChange] = useState(false);
  const dispatch = useDispatch();
  const dispatchApp = useAppDispatch();
  const user = useUser();
  const { sivcDataUpdateSuccessMsg, sivcMendatoryInfoErrorMsg } = useFieldTranslation();
  //const [isUpdate, setIsUpdate] = useState(sivChecklistData.study_id ? true : false);
  // const [validate, setValidate] = useState({
  //   siv_checklist_ib_isf: false
  // } as any);

  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const { checkPermission } = usePermissionWrapper();
  const isDisable = checkPermission('update_siv_checklist');
  const selectedRowData: any = useAppSelector(state => state.sivCheckList.selectedRowData);
  const saveButtonDisable: any = useAppSelector(state => state.sivCheckList.disableSaveButtonProps);

  const handleAdverseEventReportingData = (e: any) => {
    const val = e.target.value;
    const formattedVal = typeof val === 'string' ? formatInput(val) : val;
    const value = formattedVal;
    dispatchApp(clearMessage());
    if (e.target.type === 'radio' && value === 'Y') {
      updateAdverseEventReporting({
        ...adverseEventReportingData,
        [e.target.name]: value,
        [`${e.target.name}_comm`]: ''
      });

      //setValidate({ ...validate, [e.target.name]: false });
      updateSIVChecklistMandatoryData('adverseEventReporting', { ...mandatory, [e.target.name]: false });
    } else {
      updateAdverseEventReporting({ ...adverseEventReportingData, [e.target.name]: value });
    }
    const validateKey = `${e.target.name.replace('_comm', '')}`;
    if (e.target.name?.indexOf('_comm') !== -1) {
      if (!(value && value !== null && value !== '')) {
        //setValidate({ ...validate, [validateKey]: true });
        updateSIVChecklistMandatoryData('adverseEventReporting', { ...mandatory, [validateKey]: true });
      } else {
        //setValidate({ ...validate, [validateKey]: false });
        updateSIVChecklistMandatoryData('adverseEventReporting', { ...mandatory, [validateKey]: false });
      }
    }

    dispatch(setIsSaveButtonDisable({ ...saveButtonDisable, adverseEventReporting: false }));
    setConfirmExitValue(dispatch, true);
    //setIsChange(true);
    // setIsChanged(true);
  };

  const updateAdverseEventReportingData = async () => {
    const options = {
      site_id: selectedSite,
      study_id: studyId,
      data: {
        updated_by: user.user,
        monitoring_visit_id: selectedRowData.id,
        siv_checklist: { step_two: { adverse_event_reporting: adverseEventReportingData } }
      },
      pathVariables: {
        country: selectedCountry,
        appName: process.env.REACT_APP_NAME
      }
    };
    try {
      if (isChange) {
        if (isUpdate) {
          if (adverseEventReportingData.siv_checklist_ib_isf !== null) {
            await sendRequest('update_sivChecklist_data', options);
            if (isPublished) {
              SignatureBreaking();
            }
            getSivChecklistData('adverseEventReporting', false);
            dispatchApp(setMessage({ msgDetails: sivcDataUpdateSuccessMsg, severity: 'success' }));
            setConfirmExitValue(dispatch, false);
            setIsChange('Step2', 'adverseEventReporting', false);
          } else {
            dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
          }
        }
        if (!isUpdate) {
          if (adverseEventReportingData.siv_checklist_ib_isf !== null) {
            await sendRequest('create_sivChecklist_data', options);
            getSivChecklistData('adverseEventReporting', true);
            //setIsUpdate(true);
            setConfirmExitValue(dispatch, false);
            //setIsChange(false);
            //setIsChanged(false);
            setIsChange('Step2', 'adverseEventReporting', false);
            // store.dispatch(setSnackbarMessage('Adverse Event Reporting data is successfully saved', 'success'));
            dispatchApp(setMessage({ msgDetails: sivcDataUpdateSuccessMsg, severity: 'success' }));
          } else {
            // store.dispatch(setSnackbarMessage('Mandatory information is missing. Information cannot be saved', 'error'));
            dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
          }
        }
      } else if (!isChange && adverseEventReportingData.siv_checklist_ib_isf === null) {
        // store.dispatch(setSnackbarMessage('Mandatory information is missing. Information cannot be saved', 'error'));
        dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
      } else if (validateadverseEventReporting) {
        dispatchApp(setMessage({ msgDetails: 'No data modified', severity: 'info' }));
      } else {
        dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
      }
      dispatch(setIsSaveButtonDisable({ ...saveButtonDisable, adverseEventReporting: true }));
    } catch (e) {
      // store.dispatch(setSnackbarMessage('Mandatory information is missing. Information cannot be saved', 'error'));
      dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
    }
  };

  return (
    <>
      <AccordionDetails className="sq-checklist-tab">
        <Grid container className="checklist-radio-actions">
          <Grid md={12}>
            <Grid container>
              <Grid md={9}>
                Was the IB provided to the site and filed in the ISF?{' '}
                <Link underline="always">(Link to IB in eTMF and ISF)</Link> <span style={{ color: 'red' }}>*</span>
              </Grid>
              <Grid md={3}>
                <FormControl>
                  <RadioGroup
                    value={adverseEventReportingData.siv_checklist_ib_isf}
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="siv_checklist_ib_isf"
                    onChange={handleAdverseEventReportingData}
                  >
                    <FormControlLabel
                      disabled={!isDisable || saveDisable || !checkedInStartDate}
                      value="Y"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      disabled={!isDisable || saveDisable || !checkedInStartDate}
                      value="N"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </AccordionDetails>
      <Grid container className="fixed-buttons-block">
        <Grid md={12} display="flex" justifyContent="flex-end">
          <Stack spacing={2} direction="row">
            {isDisable ? (
              <Button
                onClick={updateAdverseEventReportingData}
                variant="text"
                disabled={saveButtonDisable.adverseEventReporting || !checkedInStartDate}
              >
                SAVE
              </Button>
            ) : (
              ''
            )}
          </Stack>
        </Grid>
      </Grid>
    </>
  );
};

export default AdverseEventReporting;
